module.exports = __webpack_public_path__ + "static/media/blob.a673e080.png";